<template>
  <div>
    <Header :active="active" />
    <img :src="top_slogan" alt="" class="banner-img" />
    <div class="w1300">
      <div class="content-nav"><span>首页</span>> <span>走进我们</span></div>
      <div class="box">
        <div class="left">
          <div id="container" style="width:500px;height:500px;border:solid 2px #656567"></div>
        </div>
        <div class="right">
          <p>承德 “热河嫂” 巾帼家政</p>
          <p>地址：承德市承德市承德市承德市</p>
          <p>电话：400-222-222222</p>
          <div class="img">
            <img src="../assets/images/12.jpg" alt="" />
            <img src="../assets/images/13.jpg" alt="" />
            <img src="../assets/images/14.jpg" alt="" />
          </div>
        </div>
      </div>
    </div>
    <Foot />
  </div>
</template>
  <script>
import Header from "../components/header.vue";
import Foot from "../components/foot.vue";
import AMapLoader from "@amap/amap-jsapi-loader";
export default {
  components: {
    Header,
    Foot,
  },
  data() {
    return {
      active: 8,
      articleList: [
        { id: 1, title: "中华全国妇女联合会章程", time: "2023-10-15" },
        {
          id: 2,
          title: "中国妇女第十三次全国代表大会闭幕",
          time: "2023-10-15",
        },
        {
          id: 3,
          title:
            "中国妇女第十三次全国代表大会在京开幕习近平等党和国家领导人到会祝贺",
          time: "2023-10-15",
        },
        { id: 4, title: "“面对面”为妇女儿童化解急难愁盼", time: "2023-10-15" },
        { id: 5, title: "暖心服务促和谐倾情化解暖民心", time: "2023-10-15" },
        { id: 6, title: "中华全国妇女联合会章程", time: "2023-10-15" },
        {
          id: 7,
          title:
            "中国妇女第十三次全国代表大会在京开幕习近平等党和国家领导人到会祝贺",
          time: "2023-10-15",
        },
      ],
      top_slogan:this.$imgUrl + localStorage.getItem('top_slogan')
      
    };
  },
  methods: {
    goInfo(id) {
      this.$router.push("/zixuninfo/" + id);
    },
    initMap() {
      AMapLoader.load({
        key: "d2b4cd0bffa28aa64829821b9a01d9fd", // 申请好的Web端开发者Key，首次调用 load 时必填
        version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: [
          "AMap.Autocomplete", //输入提示插件
          "AMap.PlaceSearch", //POI搜索插件
          "AMap.Scale", //右下角缩略图插件 比例尺
          "AMap.OverView", //地图鹰眼插件
          "AMap.ToolBar", //地图工具条
          "AMap.MapType", //类别切换控件，实现默认图层与卫星图、实施交通图层之间切换的控制
          "AMap.PolyEditor", //编辑 折线多，边形
          "AMap.CircleEditor", //圆形编辑器插件
          "AMap.Geolocation", //定位控件，用来获取和展示用户主机所在的经纬度位置
        ], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
      })
        .then((AMap) => {
          this.map = new AMap.Map("container", {
            //设置地图容器id
            // viewMode: "3D", //是否为3D地图模式
            zoom: 5, //初始化地图级别
            center: [105.602725, 37.076636], //初始化地图中心点位置
          });
          //下面使用插件
          this.map.addControl(new AMap.Scale());
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
  mounted() {
        //DOM初始化完成进行地图初始化
        this.initMap();
    }

};
</script>
  <style scoped>
.content-nav {
  border-bottom: solid 1px #bb030d;
  padding: 15px 0;
  font-size: 15px;
  margin-top: 15px;
  margin-bottom: 40px;
}
.content-nav span {
  margin-right: 10px;
  margin-left: 10px;
  color: #727272;
}
.banner-img{width: 1300px;margin: 0 auto;margin-top: 20px;display: block;}
.box {
  display: flex;
  align-items: center;
}
.right {
  margin-left: 40px;
}
.right p:first-child {
  font-size: 22px;
  margin-bottom: 30px;
  color: #000;
}
.right p {
  font-size: 14px;
  margin-bottom: 10px;
  color: #747474;
}
.img {
  margin-top: 50px;
}
.img img {
  width: 200px;
  margin-right: 30px;
}
/* .container{width: 500px;height: 500px;} */
</style>